import React from "react";
import { Link, LinkProps } from "react-router-dom";
import useBuildNavLink from "../../hooks/useBuildLink";

export interface CustomLinkProps
  extends LinkProps,
    React.RefAttributes<HTMLAnchorElement> {
  to: string;
}

function CustomLink({ to, ...restProps }: CustomLinkProps) {
  const buildNavLink = useBuildNavLink();
  const handleChangeRoute = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (restProps.target === "_self") {
      e.preventDefault();
      window.location.href = buildNavLink(to);
    }
  };
  return (
    <Link to={buildNavLink(to)} {...restProps} onClick={handleChangeRoute} />
  );
}

export default CustomLink;
